module.exports = __webpack_public_path__ + "img/logoauth.4158600d.png";